import { render, staticRenderFns } from "./ItemListSettings.vue?vue&type=template&id=56ce4d72&scoped=true"
import script from "./ItemListSettings.vue?vue&type=script&lang=js"
export * from "./ItemListSettings.vue?vue&type=script&lang=js"
import style0 from "./ItemListSettings.vue?vue&type=style&index=0&id=56ce4d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce4d72",
  null
  
)

export default component.exports